import { render, staticRenderFns } from "./ms-symptom-tabs.vue?vue&type=template&id=dc2e44a8"
import script from "./ms-symptom-tabs.vue?vue&type=script&lang=js"
export * from "./ms-symptom-tabs.vue?vue&type=script&lang=js"
import style0 from "./ms-symptom-tabs.vue?vue&type=style&index=0&id=dc2e44a8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports